














import { Component, Vue } from 'vue-property-decorator'

import Menu from '@/router/menu.ts'
@Component({
    name: 'Home'
  })
export default class Home extends Vue {
  private menuList: any[] = Menu;
}
